import {
  RangeSliderProps as MantineRangeSliderProps,
  RangeSlider as MantineRangeSlider,
} from '@mantine/core';

export type RangeSliderProps = MantineRangeSliderProps;

export const RangeSlider = MantineRangeSlider;

RangeSlider.displayName = 'RangeSlider';
